module.exports = __webpack_public_path__ + "bc15a28453dd5ac1f8e90c3c41c84da3.svg";